export default "__VITE_ASSET__DHqtOrQC__"